import { useContext } from 'react';
import { pointsContext } from '../contexts/PointsContext';

export function usePoints() {
  const value = useContext(pointsContext);
  return value;
}
